
const drawMessages = () => {
    chatMessages.forEach((m, index) => {
      ctx.font = "13px SparkyStones";
      ctx.fillStyle = m.color || "#777777";
      ctx.fillText(m.text, m.posX, m.posY);
      if (Date.now() - m.creationDate > m.timeout) {
        destroyChatMessage(index);
      }
    });
  };


  const drawStars = () => {
    let color = "white";
    stars.forEach((s) => {
      ctx.fillStyle = color;
      color = color === "white" ? "gray" : "white";
      ctx.fillRect(s[0], s[1], 2, 2);
    });
  };
  
  const drawMoon = () => {
    ctx.beginPath();
    ctx.shadowColor = "white";
    ctx.shadowOffsetX = -7;
    ctx.shadowOffsetY = 7;
    ctx.shadowBlur = 5;
    ctx.arc(100, 100, 50, 0, 2 * Math.PI, false);
    ctx.fillStyle = "#EEEEEE";
    ctx.strokeStyle = "#EEEEEE";
    ctx.fill();
    ctx.stroke();
    ctx.beginPath();
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;
    ctx.shadowBlur = 0;
    ctx.arc(110, 90, 45, 0, 2 * Math.PI, false);
    ctx.strokeStyle = "black";
    ctx.fillStyle = "black";
    ctx.fill();
    ctx.stroke();
  };
  
  const drawPath = () => {
    ctx.beginPath();
    ctx.fillStyle = "#2f260b";
    ctx.fillRect(0, GAME_HEIGHT / 2 - 50, GAME_WIDTH, 100);
    ctx.fill();
  };
  
  const drawTrees = (scroll) => {
    // TODO
  };
  
  const drawPlayer = (posX, posY) => {
    const BODY_OFFSET_X = -10;
    const BODY_OFFSET_Y = 15;
    ctx.save();
    // head
    ctx.beginPath();
    if (playerDirection === DIRECTION.LEFT) {
      ctx.translate(posX, posY);
      ctx.rotate(Math.PI);
      ctx.scale(1, -1);
      ctx.translate(-posX, -posY);
    }
    if (recoilSpeed < 0) {
      ctx.translate(posX, posY);
      ctx.rotate(0.1);
      ctx.translate(-posX, -posY);
    } else if (recoilSpeed > 0) {
      ctx.translate(posX, posY);
      ctx.rotate(-0.1);
      ctx.translate(-posX, -posY);
    }
    ctx.fillStyle = "#222222";
    ctx.arc(posX, posY, 20, 0, 2 * Math.PI, false);
    ctx.fill();
    ctx.beginPath();
    ctx.fillStyle = "black";
    ctx.arc(posX + 5, posY + 5, 15, 0, 2 * Math.PI, false);
    ctx.fill();
    // eyes
    ctx.beginPath();
    ctx.fillStyle = "green";
    ctx.arc(posX + 2, posY + 5, 2, 0, 2 * Math.PI, false);
    ctx.arc(posX + 9, posY + 5, 2, 0, 2 * Math.PI, false);
    ctx.fill();
    // body
    ctx.beginPath();
    ctx.fillStyle = "#222222";
    ctx.moveTo(posX + BODY_OFFSET_X, posY + BODY_OFFSET_Y + 5);
    ctx.lineTo(posX + BODY_OFFSET_X - 5, posY + BODY_OFFSET_Y + 40);
    ctx.lineTo(posX + BODY_OFFSET_X + 20, posY + BODY_OFFSET_Y + 40);
    ctx.lineTo(posX + BODY_OFFSET_X + 20, posY + BODY_OFFSET_Y + 5);
    ctx.fill();
    ctx.beginPath();
    ctx.fillStyle = "#222222";
    ctx.moveTo(posX + BODY_OFFSET_X + 20, posY + BODY_OFFSET_Y + 5);
    ctx.lineTo(posX + BODY_OFFSET_X + 35, posY + BODY_OFFSET_Y + 5);
    ctx.lineTo(posX + BODY_OFFSET_X + 35, posY + BODY_OFFSET_Y + 30);
    ctx.lineTo(posX + BODY_OFFSET_X + 20, posY + BODY_OFFSET_Y + 20);
    ctx.fill();
    ctx.fillStyle = "black";
    ctx.fillRect(posX + BODY_OFFSET_X + 35, posY + BODY_OFFSET_Y + 10, 10, 4);
    // staff
    ctx.fillStyle = "gray";
    ctx.fillRect(posX + BODY_OFFSET_X + 45, posY + BODY_OFFSET_Y, 4, 40);
    ctx.shadowColor = "white";
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;
    ctx.shadowBlur = 10;
    if (playerIsPoweredUp) {
      ctx.fillStyle = "crimson";
    } else {
      ctx.fillStyle = "green";
    }
    ctx.fillRect(posX + BODY_OFFSET_X + 44, posY + BODY_OFFSET_Y, 6, 6);
    // shadow
    ctx.fillStyle = "#222222";
    const blur = speedUp === 0 ? 5 : 15;
    const offset = speedUp === 0 ? 7 : GROUND_HEIGHT - posY;
    ctx.beginPath();
    ctx.ellipse(
      posX + BODY_OFFSET_X + 10,
      posY + BODY_OFFSET_Y + 40,
      10,
      5,
      0,
      0,
      Math.PI,
      true
    );
    ctx.shadowColor = "black";
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = offset;
    ctx.shadowBlur = blur;
    ctx.fill();
    ctx.restore();
  };
  
  const drawAttackChargeLoader = () => {
    ctx.beginPath();
    ctx.strokeStyle = `hsl(147, 100%, ${attackLoaderValue}%)`;
    ctx.strokeWidth = 10;
    if (attackLoaderValue >= 100) {
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 0;
      ctx.shadowBlur = 10;
    }
    ctx.arc(playerDirection === DIRECTION.RIGHT ? playerX + 37 : playerX - 37, playerY + 15, 10, 0, (attackLoaderValue / 100) * 2 * Math.PI);
    ctx.stroke();
    ctx.shadowBlur = 0;
  }
  
  const drawEnemy = (posX, posY, enemyRecoilSpeed, isAttacking) => {
    const BODY_OFFSET_X = -10;
    const BODY_OFFSET_Y = 15;
    ctx.save();
    // head
    ctx.beginPath();
    if (playerX < posX) {
      ctx.translate(posX, posY);
      ctx.rotate(Math.PI);
      ctx.scale(1, -1);
      ctx.translate(-posX, -posY);
    }
    if (enemyRecoilSpeed < 0) {
        ctx.translate(posX, posY);
        ctx.rotate(0.1);
        ctx.translate(-posX, -posY);
      } else if (enemyRecoilSpeed > 0) {
          ctx.translate(posX, posY);
          ctx.rotate(-0.1);
          ctx.translate(-posX, -posY);
        }
          ctx.fillStyle = "#444444";
    ctx.arc(posX, posY, 20, 0, 2 * Math.PI, false);
    ctx.fill();
    ctx.beginPath();
    ctx.fillStyle = "black";
    ctx.arc(posX + 5, posY + 5, 15, 0, 2 * Math.PI, false);
    ctx.fill();
    // eyes
    ctx.beginPath();
    ctx.fillStyle = "white";
    ctx.arc(posX + 2, posY + 5, 2, 0, 2 * Math.PI, false);
    ctx.arc(posX + 9, posY + 5, 2, 0, 2 * Math.PI, false);
    ctx.fill();
    // body
    ctx.beginPath();
    ctx.fillStyle = "#EEEEEE";
    ctx.moveTo(posX + BODY_OFFSET_X, posY + BODY_OFFSET_Y + 5);
    ctx.lineTo(posX + BODY_OFFSET_X - 5, posY + BODY_OFFSET_Y + 40);
    ctx.lineTo(posX + BODY_OFFSET_X + 20, posY + BODY_OFFSET_Y + 40);
    ctx.lineTo(posX + BODY_OFFSET_X + 20, posY + BODY_OFFSET_Y + 5);
    ctx.fill();
    ctx.beginPath();
    ctx.fillStyle = "#EEEEEE";
    ctx.moveTo(posX + BODY_OFFSET_X + 20, posY + BODY_OFFSET_Y + 5);
    ctx.lineTo(posX + BODY_OFFSET_X + 35, posY + BODY_OFFSET_Y + 5);
    ctx.lineTo(posX + BODY_OFFSET_X + 35, posY + BODY_OFFSET_Y + 10);
    ctx.lineTo(posX + BODY_OFFSET_X + 20, posY + BODY_OFFSET_Y + 20);
    ctx.fill();
    ctx.fillStyle = "black";
    ctx.fillRect(posX + BODY_OFFSET_X + 35, posY + BODY_OFFSET_Y + 10, 10, 4);
    // sword
    ctx.save();
    if (isAttacking) {
      if (playerX > posX) {
        ctx.translate(posX, posY);
        ctx.rotate(Math.PI / 2);
        ctx.scale(1, 1);
        ctx.translate(-posX - 15, -posY - 55);
      } else {
        ctx.translate(posX, posY);
        ctx.rotate(Math.PI / 2);
        ctx.scale(1, 1);
        ctx.translate(-posX - 15, -posY - 55);
      }
    }
    ctx.fillStyle = "gray";
    ctx.fillRect(posX + BODY_OFFSET_X + 45, posY + BODY_OFFSET_Y + 5, 4, -35);
    ctx.fillRect(posX + BODY_OFFSET_X + 46, posY + BODY_OFFSET_Y - 30, 2, -2);
    ctx.fillStyle = "white";
    ctx.fillRect(posX + BODY_OFFSET_X + 45, posY + BODY_OFFSET_Y + 5, 4, 10);
    ctx.fillRect(posX + BODY_OFFSET_X + 38, posY + BODY_OFFSET_Y + 5, 10, 3);
    ctx.fillRect(posX + BODY_OFFSET_X + 46, posY + BODY_OFFSET_Y + 5, 10, 3);
    ctx.restore();
    // shield
    ctx.fillStyle = "crimson";
    ctx.fillRect(posX + BODY_OFFSET_X - 10, posY + BODY_OFFSET_Y + animShieldValue, 20, 30);
    ctx.beginPath();
    ctx.arc(posX + BODY_OFFSET_X, posY + BODY_OFFSET_Y + 30 + animShieldValue, 10, 0, Math.PI);
    ctx.fill();
    ctx.restore();
  };
  
  const drawBoss = (posX, posY, isAttacking, hp) => {
    const BODY_OFFSET_X = -10;
    const BODY_OFFSET_Y = 15;
    posY -= 40;
    ctx.save();
    // head
    ctx.beginPath();
    if (playerX < posX) {
      ctx.translate(posX, posY);
      ctx.rotate(Math.PI);
      ctx.scale(1, -1);
      ctx.translate(-posX, -posY);
    }
          ctx.fillStyle = "#444444";
    ctx.arc(posX, posY, 40, 0, 2 * Math.PI, false);
    ctx.fill();
    ctx.beginPath();
    ctx.fillStyle = "black";
    ctx.arc(posX + 5, posY + 5, 30, 0, 2 * Math.PI, false);
    ctx.fill();
    // eyes
    ctx.beginPath();
    ctx.fillStyle = "white";
    ctx.arc(posX + 2, posY + 5, 4, 0, 2 * Math.PI, false);
    ctx.arc(posX + 11, posY + 5, 4, 0, 2 * Math.PI, false);
    ctx.fill();
    // body
    ctx.beginPath();
    ctx.fillStyle = "#EEEEEE";
    ctx.moveTo(posX + BODY_OFFSET_X, posY + BODY_OFFSET_Y + 10);
    ctx.lineTo(posX + BODY_OFFSET_X - 10, posY + BODY_OFFSET_Y + 80);
    ctx.lineTo(posX + BODY_OFFSET_X + 40, posY + BODY_OFFSET_Y + 80);
    ctx.lineTo(posX + BODY_OFFSET_X + 40, posY + BODY_OFFSET_Y + 10);
    ctx.fill();
    ctx.beginPath();
    ctx.fillStyle = "#EEEEEE";
    ctx.moveTo(posX + BODY_OFFSET_X + 40, posY + BODY_OFFSET_Y + 10);
    ctx.lineTo(posX + BODY_OFFSET_X + 70, posY + BODY_OFFSET_Y + 10);
    ctx.lineTo(posX + BODY_OFFSET_X + 70, posY + BODY_OFFSET_Y + 20);
    ctx.lineTo(posX + BODY_OFFSET_X + 40, posY + BODY_OFFSET_Y + 40);
    ctx.fill();
    ctx.fillStyle = "black";
    ctx.fillRect(posX + BODY_OFFSET_X + 35, posY + BODY_OFFSET_Y + 10, 20, 8);
    // sword
    ctx.save();
    if (isAttacking) {
      if (playerX > posX) {
        ctx.translate(posX, posY);
        ctx.rotate(Math.PI / 2);
        ctx.scale(1, 1);
        ctx.translate(-posX - 15, -posY - 55);
      } else {
        ctx.translate(posX, posY);
        ctx.rotate(Math.PI / 2);
        ctx.scale(1, 1);
        ctx.translate(-posX - 15, -posY - 55);
      }
    }
    ctx.fillStyle = "gray";
    ctx.fillRect(posX + BODY_OFFSET_X + 60, posY + BODY_OFFSET_Y + 5, 8, -70);
    ctx.fillRect(posX + BODY_OFFSET_X + 61, posY + BODY_OFFSET_Y - 64, 6, -4);
    ctx.fillRect(posX + BODY_OFFSET_X + 62, posY + BODY_OFFSET_Y - 68, 4, -4);
    ctx.fillStyle = "white";
    ctx.fillRect(posX + BODY_OFFSET_X + 60, posY + BODY_OFFSET_Y + 5, 8, 20);
    ctx.fillRect(posX + BODY_OFFSET_X + 53, posY + BODY_OFFSET_Y + 5, 20, 6);
    ctx.fillRect(posX + BODY_OFFSET_X + 61, posY + BODY_OFFSET_Y + 5, 20, 6);
    ctx.restore();
    // shield
    ctx.fillStyle = "brown";
    ctx.fillRect(posX + BODY_OFFSET_X - 10, posY + BODY_OFFSET_Y + 10 + animShieldValue, 40, 60);
    ctx.beginPath();
    ctx.arc(posX + BODY_OFFSET_X + 10, posY + BODY_OFFSET_Y + 70 + animShieldValue, 20, 0, Math.PI);
    ctx.fill();
    ctx.restore();
    // HP bar
    for (let i = 0; i <= hp; i++) {
      drawHearth(posX + i * 7 - hp * 7, posY - 60, 0.07, true, "green");
    }
  };
  
  const drawSkeleton = (posX, posY, isAttacking) => {
    const BODY_OFFSET_X = -10;
    const BODY_OFFSET_Y = 15;
    ctx.save();
    // head
    ctx.beginPath();
    if (playerX > posX && enemies.length > 0 || playerX < posX && enemies.length === 0) {
      ctx.translate(posX, posY);
      ctx.rotate(Math.PI);
      ctx.scale(1, -1);
      ctx.translate(-posX, -posY);
    }
  
    ctx.beginPath();
    ctx.fillStyle = "#CCCCCC";
    ctx.fillRect(posX - 2, posY, 20, 20);
    ctx.fill();
    // eyes
    ctx.fillStyle = "black";
    ctx.fillRect(posX + 1, posY + 5, 5, 5);
    ctx.fillRect(posX + 12, posY + 5, 5, 5);
    // skull details
    ctx.beginPath();
    ctx.fillStyle = "black";
    ctx.fillRect(posX + 3, posY + 15, 3, 5);
    ctx.fillRect(posX + 7, posY + 15, 3, 5);
    ctx.fillRect(posX + 11, posY + 15, 3, 5);
    ctx.fill();
    // body
    ctx.beginPath();
    ctx.fillStyle = "black";
    ctx.moveTo(posX + BODY_OFFSET_X, posY + BODY_OFFSET_Y + 5);
    ctx.lineTo(posX + BODY_OFFSET_X - 5, posY + BODY_OFFSET_Y + 40);
    ctx.lineTo(posX + BODY_OFFSET_X + 20, posY + BODY_OFFSET_Y + 40);
    ctx.lineTo(posX + BODY_OFFSET_X + 20, posY + BODY_OFFSET_Y + 5);
    ctx.fill();
    ctx.beginPath();
    ctx.fillStyle = "black";
    ctx.moveTo(posX + BODY_OFFSET_X + 20, posY + BODY_OFFSET_Y + 5);
    ctx.lineTo(posX + BODY_OFFSET_X + 35, posY + BODY_OFFSET_Y + 5);
    ctx.lineTo(posX + BODY_OFFSET_X + 35, posY + BODY_OFFSET_Y + 10);
    ctx.lineTo(posX + BODY_OFFSET_X + 20, posY + BODY_OFFSET_Y + 20);
    ctx.fill();
    ctx.fillStyle = "#CCCCCC";
    ctx.fillRect(posX + BODY_OFFSET_X + 35, posY + BODY_OFFSET_Y + 10, 10, 4);
    // sword
    ctx.save();
    if (isAttacking) {
      if (playerX > posX) {
        ctx.translate(posX, posY);
        ctx.rotate(Math.PI / 2);
        ctx.scale(1, 1);
        ctx.translate(-posX - 15, -posY - 55);
      } else {
        ctx.translate(posX, posY);
        ctx.rotate(Math.PI / 2);
        ctx.scale(1, 1);
        ctx.translate(-posX - 15, -posY - 55);
      }
    }
    ctx.fillStyle = "gray";
    ctx.fillRect(posX + BODY_OFFSET_X + 45, posY + BODY_OFFSET_Y + 5, 4, -35);
    ctx.fillRect(posX + BODY_OFFSET_X + 46, posY + BODY_OFFSET_Y - 30, 2, -2);
    ctx.fillStyle = "white";
    ctx.fillRect(posX + BODY_OFFSET_X + 45, posY + BODY_OFFSET_Y + 5, 4, 10);
    ctx.fillRect(posX + BODY_OFFSET_X + 38, posY + BODY_OFFSET_Y + 5, 10, 3);
    ctx.fillRect(posX + BODY_OFFSET_X + 46, posY + BODY_OFFSET_Y + 5, 10, 3);
    ctx.restore();
    // shadow
    ctx.fillStyle = "#222222";
    const blur = 5;
    const offset = 7;
    ctx.beginPath();
    ctx.ellipse(
      posX + BODY_OFFSET_X + 10,
      posY + BODY_OFFSET_Y + 40,
      10,
      5,
      0,
      0,
      Math.PI,
      true
    );
    ctx.shadowColor = "black";
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = offset;
    ctx.shadowBlur = blur;
    ctx.fill();
    ctx.restore();
  };
  
  const drawBigSkeleton = (posX, posY, isAttacking) => {
    const BODY_OFFSET_X = -10;
    const BODY_OFFSET_Y = 15;
    posY -= 40;
    ctx.save();
    // head
    ctx.beginPath();
    if (playerX > posX && enemies.length > 0 || playerX < posX && enemies.length === 0) {
      ctx.translate(posX, posY);
      ctx.rotate(Math.PI);
      ctx.scale(1, -1);
      ctx.translate(-posX, -posY);
    }
        ctx.beginPath();
        ctx.fillStyle = "#CCCCCC";
        ctx.fillRect(posX - 10, posY - 20, 40, 40);
        ctx.fill();
        // eyes
        ctx.fillStyle = "black";
        ctx.fillRect(posX + 1, posY -10, 10, 10);
        ctx.fillRect(posX + 15, posY -10, 10, 10);
        // skull details
        ctx.beginPath();
        ctx.fillStyle = "black";
        ctx.fillRect(posX + 3, posY + 15, 4, 5);
        ctx.fillRect(posX + 9, posY + 15, 4, 5);
        ctx.fillRect(posX + 15, posY + 15, 4, 5);
        ctx.fill();
    // body
    ctx.beginPath();
    ctx.fillStyle = "black";
    ctx.moveTo(posX + BODY_OFFSET_X, posY + BODY_OFFSET_Y + 10);
    ctx.lineTo(posX + BODY_OFFSET_X - 10, posY + BODY_OFFSET_Y + 80);
    ctx.lineTo(posX + BODY_OFFSET_X + 40, posY + BODY_OFFSET_Y + 80);
    ctx.lineTo(posX + BODY_OFFSET_X + 40, posY + BODY_OFFSET_Y + 10);
    ctx.fill();
    ctx.beginPath();
    ctx.fillStyle = "black";
    ctx.moveTo(posX + BODY_OFFSET_X + 40, posY + BODY_OFFSET_Y + 10);
    ctx.lineTo(posX + BODY_OFFSET_X + 70, posY + BODY_OFFSET_Y + 10);
    ctx.lineTo(posX + BODY_OFFSET_X + 70, posY + BODY_OFFSET_Y + 20);
    ctx.lineTo(posX + BODY_OFFSET_X + 40, posY + BODY_OFFSET_Y + 40);
    ctx.fill();
    ctx.fillStyle = "black";
    ctx.fillRect(posX + BODY_OFFSET_X + 35, posY + BODY_OFFSET_Y + 10, 20, 8);
    // sword
    ctx.save();
    if (isAttacking) {
      if (playerX > posX) {
        ctx.translate(posX, posY);
        ctx.rotate(Math.PI / 2);
        ctx.scale(1, 1);
        ctx.translate(-posX - 15, -posY - 55);
      } else {
        ctx.translate(posX, posY);
        ctx.rotate(Math.PI / 2);
        ctx.scale(1, 1);
        ctx.translate(-posX - 15, -posY - 55);
      }
    }
    ctx.fillStyle = "gray";
    ctx.fillRect(posX + BODY_OFFSET_X + 60, posY + BODY_OFFSET_Y + 5, 8, -70);
    ctx.fillRect(posX + BODY_OFFSET_X + 61, posY + BODY_OFFSET_Y - 64, 6, -4);
    ctx.fillRect(posX + BODY_OFFSET_X + 62, posY + BODY_OFFSET_Y - 68, 4, -4);
    ctx.fillStyle = "white";
    ctx.fillRect(posX + BODY_OFFSET_X + 60, posY + BODY_OFFSET_Y + 5, 8, 20);
    ctx.fillRect(posX + BODY_OFFSET_X + 53, posY + BODY_OFFSET_Y + 5, 20, 6);
    ctx.fillRect(posX + BODY_OFFSET_X + 61, posY + BODY_OFFSET_Y + 5, 20, 6);
    ctx.restore();
    ctx.restore();
  };

  const drawGameOver = () => {
    ctx.fillStyle = "rgba(100, 0, 0, 0.6)";
    ctx.fillRect(0, 70, GAME_WIDTH, 50);
    ctx.font = "24px SparkyStones";
    ctx.fillStyle = "black";
    ctx.fillText("You died", GAME_WIDTH / 2 - 20, 95);
    ctx.font = "18px SparkyStones";
    ctx.fillStyle = "#111111";
    ctx.fillText("Tap or press Enter", GAME_WIDTH / 2 - 20, 115);
    ctx.font = "20px SparkyStones";
    ctx.fillStyle = "white";
    ctx.fillText(`Wave ${waveNumber}`, GAME_WIDTH / 2 - 130, 135);
    ctx.fillText(`Kills: ${killCount}`, GAME_WIDTH / 2 - 20, 135);
    ctx.fillText(`Skeletons raised: ${skeletonsRaised}`, GAME_WIDTH / 2 + 90, 135);
  }
  
  const drawButton = (x, y, text, enabled) => {
    ctx.fillStyle = enabled ? "#EEEEEE" : "#AAAAAA";
    ctx.fillRect(x - 2, y - 12, 90, 75);
    ctx.fillStyle = enabled ? "#333333" : "#222222";
    ctx.fillRect(x - 5, y - 15, 90, 75);
    ctx.fillStyle = enabled ? "white" : "gray";
    ctx.fillText(text, x + 15, y + 15);
  };
  
  const drawPauseButton = (x, y, text) => {
    ctx.fillStyle = "#EEEEEE";
    ctx.fillRect(x - 2, y - 12, 30, 30);
    ctx.fillStyle = "#333333";
    ctx.fillRect(x - 5, y - 15, 30, 30);
    ctx.fillStyle = "white";
    ctx.fillText(text, x + 2, y + 5);
  };
  
  const drawUI = () => {
    ctx.fillStyle = "#111111";
    ctx.fillRect(0, GAME_HEIGHT - 80, GAME_WIDTH, GAME_HEIGHT);
    ctx.beginPath();
    ctx.fillStyle = "blue";
    ctx.strokeStyle = "deepskyblue";
    ctx.fillRect(50, 40, mana, 20);
    ctx.strokeRect(50, 40, 100, 20);
    ctx.fill();
    ctx.stroke();
    for (let i = 1; i < maxLives + 1; i++) {
      drawHearth(30 + 30 * i, 20, 0.2, i <= lives);
    }
    if (enemies.length === 0) {
      ctx.font = "24px SparkyStones";
      ctx.fillStyle = "white";
      ctx.fillText("Next wave in", GAME_WIDTH - 180, 30);
      ctx.fillStyle = "white";
      ctx.fillText(restCountdown, GAME_WIDTH - 40, 30);
    } else {
      ctx.font = "24px SparkyStones";
      ctx.fillStyle = "deepskyblue";
      if (waveNumber % BOSS_FREQUENCY === 0) {
        ctx.fillText('Boss', GAME_WIDTH - 120, 30);
      } else {
        ctx.fillText(`Wave ${waveNumber}`, GAME_WIDTH - 120, 30);
  
      }
    }
    ctx.font = "24px SparkyStones";
    ctx.fillStyle = "white";
    ctx.fillText(`Kills: ${killCount}`, GAME_WIDTH - 120, 50);
  
    // draw touch controls
    // TODO: only on mobile!
    if (isMobileDevice) {
      buttons.forEach(btn => {
        drawButton(btn.x, btn.y, btn.text, btn.enableCondition());
      });
    }
    // TODO: enable pause button. Current implementation doesn't work
    // drawPauseButton(GAME_WIDTH - 300, 20, "P");
  };
  
  const drawHints = () => {
    // arrow up
    if (!keyHaveBeenPressedOnce.up) {
      ctx.fillStyle = "rgba(255, 255, 255, 0.7)";
      ctx.fillRect(playerX - 15, playerY - 80, 50, 50);
      ctx.font = "12px SparkyStones";
      ctx.fillStyle = "blue";
      ctx.fillText("up (jump)", playerX - 14, playerY - 50);
    }
    if (!keyHaveBeenPressedOnce.left) {
      ctx.fillStyle = "rgba(255, 255, 255, 0.7)";
      ctx.fillRect(playerX - 80, playerY, 50, 50);
      ctx.fillStyle = "blue";
      ctx.font = "16px SparkyStones";
      ctx.fillText("left", playerX - 70, playerY + 30);
    }
    if (!keyHaveBeenPressedOnce.right) {
      ctx.fillStyle = "rgba(255, 255, 255, 0.7)";
      ctx.fillRect(playerX + 50, playerY, 50, 50);
      ctx.fillStyle = "blue";
      ctx.font = "16px SparkyStones";
      ctx.fillText("right", playerX + 60, playerY + 30);
    }
    if (!keyHaveBeenPressedOnce.f) {
      ctx.fillStyle = "rgba(255, 255, 255, 0.7)";
      ctx.fillRect(playerX - 15, playerY + 80, 50, 50);
      ctx.fillStyle = "green";
      ctx.font = "12px SparkyStones";
      ctx.fillText("f (fire)", playerX - 10, playerY + 110);
    }
    // raise undead
    if (corpses.length === 1) {
      ctx.fillStyle = "rgba(255, 255, 255, 0.7)";
      ctx.fillRect(corpses[0].posX - 20, corpses[0].posY - 60, 50, 50);
      ctx.font = "16px SparkyStones";
      ctx.fillStyle = "black";
      ctx.fillText("r", corpses[0].posX + 5, corpses[0].posY - 40);
      ctx.fillText("(raise)", corpses[0].posX - 15, corpses[0].posY - 30);
    }
    if (!keyHaveBeenPressedOnce.e && mana < 50) {
      ctx.fillStyle = "lightgreen";
      ctx.font = "14px SparkyStones";
      ctx.fillText("You can press -e- to cast the evocation spell.", 210, GAME_HEIGHT - 140);
      ctx.fillText("It will cost you a life and won't be able to move for a while.", 210, GAME_HEIGHT - 120);
    }
  }


  const drawEnemies = () => {
    enemies.forEach((enemy) => {
      if (enemy.isBoss) {
        drawBoss(enemy.posX, GROUND_HEIGHT, enemy.isAttacking, enemy.hp);
      } else {
        drawEnemy(enemy.posX, GROUND_HEIGHT, enemy.recoilSpeed, enemy.isAttacking);
      }
    });
  };
  
  const drawCorpses = () => {
    corpses.forEach((corpse) => {
      if (corpse.isBoss) {
        ctx.filter = "invert()";
      }
      ctx.fillStyle = "gray";
      ctx.fillRect(corpse.posX - 20, GROUND_HEIGHT + 45, 40, 5);
      ctx.fillRect(corpse.posX - 10, GROUND_HEIGHT + 45, 20, -20);
      ctx.beginPath();
      ctx.fillStyle = "gray";
      ctx.arc(corpse.posX, GROUND_HEIGHT + 25, 10, 0, Math.PI, true);
      ctx.fill();
      ctx.font = "10px SparkyStones";
      ctx.fillStyle = "black";
      ctx.fillText("RIP", corpse.posX - 8, corpse.posY + 35);
      if (corpse.isBoss) {
        ctx.fillText("(Boss)", corpse.posX - 13, corpse.posY + 13);
      }
      ctx.filter = "none";
    });
  };
  
  const drawSkeletons = () => {
    skeletons.forEach((skeleton) => {
      if (skeleton.isBoss) {
        drawBigSkeleton(skeleton.posX, GROUND_HEIGHT, skeleton.isAttacking);
      } else {
        drawSkeleton(skeleton.posX, GROUND_HEIGHT, skeleton.isAttacking);
      }
    });
  };
  
  const drawItems = () => {
    items.forEach((item) => {
      switch (item.kind) {
        case ITEMS.MANA:
          ctx.beginPath();
          ctx.fillStyle = "rgba(255, 255, 255, 0.3)";
          ctx.arc(item.posX, item.posY, 15, 0, Math.PI * 2);
          ctx.fill();
          ctx.beginPath();
          ctx.fillStyle = "#DDDDFF";
          ctx.arc(item.posX, item.posY, 10, 0, Math.PI * 2);
          ctx.fill();
          ctx.beginPath();
          ctx.fillStyle = "#AAAAFF";
          ctx.arc(item.posX, item.posY, 8, 0, Math.PI * 2);
          ctx.fill();
          ctx.beginPath();
          ctx.fillStyle = "#8888FF";
          ctx.arc(item.posX, item.posY, 6, 0, Math.PI * 2);
          ctx.fill();
          break;
        case ITEMS.HEAL:
          drawHearth(item.posX, item.posY, 0.15, true, "pink");
          break;
          case ITEMS.POWERUP:
            ctx.fillStyle = "green";
            ctx.fillRect(item.posX, item.posY, 27, 20);
            ctx.font = "10px SparkyStones";
            ctx.fillStyle = "white";
            ctx.fillText("POW", item.posX + 2, item.posY + 12);
            break;
            case ITEMS.EXTRA_LIFE:
              drawHearth(item.posX, item.posY, 0.2, true);
          break;
      }
    });
  };
  
  const drawHearth = (x, y, scale = 0.2, isFull, fillColor) => {
    ctx.save();
    ctx.scale(scale, scale);
    ctx.beginPath();
    ctx.fillStyle = fillColor || "crimson";
    ctx.strokeStyle = "crimson";
    ctx.lineWidth = 3;
    const posX = x / scale;
    const posY = y / scale;
    ctx.moveTo(posX, posY); // 75 40
    ctx.bezierCurveTo(posX, posY - 3, posX - 5, posY - 15, posX - 25, posY - 15);
    ctx.bezierCurveTo(
      posX - 55,
      posY - 15,
      posX - 55,
      posY + 22.5,
      posX - 55,
      posY + 22.5
    );
    ctx.bezierCurveTo(
      posX - 55,
      posY + 40,
      posX - 35,
      posY + 62,
      posX,
      posY + 80
    );
    ctx.bezierCurveTo(
      posX + 35,
      posY + 62,
      posX + 55,
      posY + 40,
      posX + 55,
      posY + 22.5
    );
    ctx.bezierCurveTo(
      posX + 55,
      posY + 22.5,
      posX + 55,
      posY - 15,
      posX + 25,
      posY - 15
    );
    ctx.bezierCurveTo(posX + 10, posY - 15, posX, posY - 3, posX, posY);
    if (isFull) {
      ctx.fill();
    }
    ctx.stroke();
    ctx.restore();
  };

  
const drawTitle = () => {
  // upper section
  ctx.fillStyle = "#333333";
  ctx.fillRect(0, 20, canvas.width, 250);
  ctx.fillStyle = "mediumseagreen";
  ctx.font = "80px SparkyStones";
  ctx.fillText("SKELEATHON", 250, 150);
  playerX = 0;
  drawPlayer(100, 200);
  drawSkeleton(180, 200);
  drawSkeleton(220, 200);
  drawSkeleton(250, 200);
  drawSkeleton(350, 200, true);
  drawEnemy(650, 200);
  drawEnemy(750, 200);
  ctx.fillStyle = "white";
  ctx.font = "13px SparkyStones";
  // bottom section
  ctx.strokeStyle = "white";
  ctx.fillStyle = "rgba(50, 50, 50, 0.8)";
  ctx.strokeRect(10, 300, canvas.width - 20, 170);
  ctx.fillRect(10, 300, canvas.width - 20, 170);
  // Introduction
  ctx.fillStyle = "white";
  ctx.fillText(
    "You are a necromancer.",
    20,
    320
    );
    ctx.fillText(
      "Forces of good want to destroy you. But nobody can stop your dark plans...",
      20,
      340
      );
      ctx.fillText(
        "Use arrows to move and jump. Use F to fire your deadly magic. Use R near a grave to raise a skeleton. Use E to refill mana paying 1 life.",
        20,
        380
        );
        ctx.fillText("The game never ends... how many waves are you able to survive?", 20, 400);
  ctx.font = "14px SparkyStones";
  ctx.fillText(
    "Tap or press Enter to start",
    canvas.width - 180,
    canvas.height - 20
    );
  ctx.font = "12px SparkyStones";
  ctx.fillText("Random tip: " + randomTip, 20, 460);
};

const drawTriangle = (posX, posY, height, width, color) => {
  ctx.beginPath();
  ctx.moveTo(posX, height + posY);
  ctx.lineTo(width / 2 + posX, posY);
  ctx.lineTo(width + posX, height + posY);
  ctx.fillStyle = color;
  ctx.fill();
  ctx.closePath();
}

const drawLandscape = () => {
  const far = "#0F0F0F";
  const mid = "#101A10";
  const near = "#112211";  

  drawTriangle(-20, GAME_HEIGHT / 2 - 92, 50, 120, far);
  drawTriangle(50, GAME_HEIGHT / 2 - 92, 50, 120, mid);
  drawTriangle(150, GAME_HEIGHT / 2 - 92, 50, 120, mid);
  drawTriangle(230, GAME_HEIGHT / 2 - 92, 50, 150, far);
  drawTriangle(300, GAME_HEIGHT / 2 - 92, 50, 120, near);
  drawTriangle(400, GAME_HEIGHT / 2 - 92, 50, 120, mid);
  drawTriangle(500, GAME_HEIGHT / 2 - 92, 50, 120, near);
  drawTriangle(600, GAME_HEIGHT / 2 - 92, 50, 120, mid);
  drawTriangle(700, GAME_HEIGHT / 2 - 92, 50, 120, far);
  drawTriangle(750, GAME_HEIGHT / 2 - 92, 50, 120, mid);
}